import { environment } from "../../core/config/environment";

export const getEnvironmentName = (): string => {
  const dbStore = environment.dbStore;
  if (dbStore === "bqe") {
    return "production";
  }
  return dbStore.replace("bqe-", "");
};